import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Planner from "@/pages/Planner";
import PrioritiesPage from "@/pages/PrioritiesPage";
import ArchivePage from "@/pages/ArchivePage";
import ActivitiesPage from "@/pages/ActivitiesPage";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Planner />} />
          <Route path="/priorities" element={<PrioritiesPage />} />
          <Route path="/activities" element={<ActivitiesPage />} />
          <Route path="/archive" element={<ArchivePage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
